import { render, staticRenderFns } from "./teacherSelector.vue?vue&type=template&id=1ef411e0"
import script from "./teacherSelector.vue?vue&type=script&lang=js"
export * from "./teacherSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports